// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".agency-select-item[data-v-e4087592]  .el-form-item__content {\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
